/**
 * Drives the mobile dot indicators for the product image gallery. Dawn's base <slider-component>
 * (used by the gallery) already dispatches a 'slideChanged' event whenever the visible slide
 * changes (from scrolling/swiping) — this just listens for that to keep the active dot in sync,
 * and makes each dot clickable to jump straight to that image.
 */
(function () {
  function setupDots(dotsContainer) {
    var sliderComponent = dotsContainer.closest('slider-component');
    if (!sliderComponent) return;

    var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-gallery-dot]'));
    var slides = Array.prototype.slice.call(sliderComponent.querySelectorAll('.slider__slide'));

    sliderComponent.addEventListener('slideChanged', function (event) {
      var page = event.detail && event.detail.currentPage;
      if (!page) return;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === page - 1);
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        var target = slides[index];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-gallery-dots]').forEach(setupDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
